<template>
  <div class="review-wrap">
    <!-- 24.5.17 精彩回顾 dxm -->
    <div class="container">
      <h2 class="h2-title">{{$t("home.exciting")}}</h2>
      <div class="list">
        <div class="item" v-for="(item, index) in listCate" :key="index" @click="changeExdetail(item)">
          <img class="img" :src="$imgUrl+item.cover_url" alt="" />
          <div class="title">{{ item.name }}</div>
          <!-- <div class="tips">{{ item.type }}</div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    listCate:Array
  },
  data() {
    return {
    
    };
  },
  mounted() {
    this.langSet = localStorage.getItem("languageSet") || "cn";
  },
  methods:{
    changeExdetail(item){
      this.$emit('changeExdetail',item)
    }
  }
};
</script>
<style lang="scss" scoped>
.review-wrap {
  width: 100%;
  padding: 120px 0 70px;
  .list {
    display: flex;
    flex-wrap: wrap;
    margin-top: 40px;
    .item {
      width: 304px;
      font-size: 16px;
      cursor: pointer;
      color: #757575;
      line-height: 22px;
      text-align: center;
      margin: 0 21px 50px 0;
      &:hover .title{
        color: #233889;
      }
      &:nth-child(4n) {
        margin-right: 0;
      }
      .img {
        width: 100%;
        height: 185px;
        display: block;
      }
      .title {
        font-size: 16px;
        font-weight: 500;
        color: #2c2c2e;
        line-height: 30px;
        margin: 15px 0 5px;
      }
    }
  }
}
@media only screen and (max-width: 1280px) {
  .review-wrap{
    .list{
      justify-content: center;
      .item{
        width: 30%;
        margin-right: 20px;
      }
    }
  }
}
@media only screen and (max-width: 767px) {
  .review-wrap{
    padding: 50px 0;
    .list{
      margin-top: 20px;
      justify-content: space-around;
      .item{
        width: 45%;
        font-size: 14px;
        line-height: 17px;
        margin-right: 0;
        margin-bottom: 20px;
        .img{
          height: 2rem;
        }
        .title{
          font-size: 17px;
          line-height: 25px;
          margin: 10px 0 5px 0;
        }
      }
    }
  }
}
</style>